import { CreateLaborTaskAssignmentMutation } from "~/gql/mutations/produce/productionLaborSchedule.generated";
import { GetLaborDemandQuery } from "~/gql/queries/produce/productionLaborSchedule.generated";

const taskAssignmentEndpoints = {
	UnassignTask: { invalidatesTags: ["TaskAssignments"] as AddTagTypes },
	CancelLaborTask: {
		invalidatesTags: ["TaskAssignments"] as AddTagTypes
	},
	ChangeTaskAssignmentDueDate: {
		invalidatesTags: ["TaskAssignments"] as AddTagTypes
	},
	CompleteTask: {
		invalidatesTags: ["TaskAssignments"] as AddTagTypes
	},
	CreateLaborTaskAssignment: {
		invalidatesTags: ["TaskAssignments", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: CreateLaborTaskAssignmentMutation) => res
	},
	GetLaborDemand: {
		providesTags: ["TaskAssignments"] as AddTagTypes,
		transformResponse: (res: GetLaborDemandQuery) => res
	},
	ReassignTask: {
		invalidatesTags: ["TaskAssignments"] as AddTagTypes
	},
	StartTask: {
		invalidatesTags: ["TaskAssignments"] as AddTagTypes
	}
};

export default taskAssignmentEndpoints;
